<template>
  <div id="Safety" class="bg-color1" style="height:calc(100vh);">
    <div ref="app_head" class="col-12 lh40 bg-color-white b-s-2 pl5 pr5 fixed-t">
        <div class="col-3 f18" @click="$router.back(-1)"><i class="iconfont icon-31fanhui1 color-primary"></i></div>
        <div class="col-6 t-c color-primary"><span class="f24 fw">S</span>eguridad</div>
        <div class="col-3 t-r f26"></div>
    </div>
    <div class="h4"></div>
    <div class="col-12 mt8">
      <div class="col-12 bg-color-white f14 pl8 pr8">
        <div class="col-12 lh50 bb1">
          <div class="col-4 t-l color-muted">Contraseña actual</div>
          <div class="col-8 t-r"><input type="text" name="" v-model="old_password" class="t-r"></div>
        </div>
        <div class="col-12 lh50 bb1">
          <div class="col-4 t-l color-muted">Nueva contraseña</div>
          <div class="col-8 t-r"><input type="text" name="" v-model="password" class="t-r"></div>
        </div>
        <div class="col-12 lh50 bb1">
          <div class="col-4 t-l color-muted">Nueva contraseña</div>
          <div class="col-8 t-r"><input type="text" name="" v-model="re_password" class="t-r"></div>
        </div>
      </div>
      <div class="col-12 mb10 mt10 pl20 pr20">
        <button class="bg-color-primary color-white w-100 lh40 r5" @click="save()">Guardar</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Safety',
  data () {
    return {
      old_password: '',
      password: '',
      re_password: ''
    }
  },
  created: function () {
  },
  methods: {
    save: function () {
      //判断如果新密码和确认密码不一致，或者新密码和旧密码一样，或者新密码为空，或者旧密码为空，或者确认密码为空，都不允许提交
      if(this.password != this.re_password || this.old_password == this.password || this.password == '' || this.old_password == '' || this.re_password == ''){
        this.$store.commit('setAlert',{type:'error',msg: "Error"});
        return false;
      }
      let post_data = {}
      post_data.password = this.password
      post_data.old_password = this.old_password
      this.post(this.api_url + 'manage/account_safety_update',post_data,true).then((res)=>{
        if(res.status == 1){
          this.$store.commit('setAlert',{type:'success',msg: "Success"});
          this.$router.back(-1);
        }else{
          this.$store.commit('setAlert',{type:'error',msg: "Error"});
        }
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Main/Safety.vue